import { render } from "./PropostasComerciais.vue?vue&type=template&id=cdba9b4c"
import script from "./PropostasComerciais.vue?vue&type=script&lang=js"
export * from "./PropostasComerciais.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__